<template>

<div class="wrapper">

    <div class="quadrants">

        <div class="quadrant" v-for="(quadrant, index) in quadrants" :key="index">

            <div class="segment" :class="{'is-selected': selected === segment.id}" :data-band="segment.band" v-for="(segment, index) in quadrant.segments" :key="index" v-on:click="$emit('click', segment.id)">

                <div class="segment-value">{{ segment.count }}</div>

            </div>

        </div>

    </div>

    <div class="label is-left"><span>&#8592;</span> {{ labels[0] }}</div>
    <div class="label is-right">{{ labels[1] }} <span>&#8594;</span></div>
    <div class="label is-top"><span>&#8592;</span>  {{ labels[2] }}</div>
    <div class="label is-bottom">{{ labels[3] }} <span>&#8594;</span></div>

    <div class="center" :class="{'is-selected': selected === false}" v-on:click="$emit('click', false)">All</div>

</div>

</template>

<script>

export default {

	props: ['data', 'title', 'labels', 'selected'],

    data: function() {

        return {
            titles: [
                
            ]
        }

    },

    computed: {

        quadrants: function() {

            var quadrants = [], segments, index, band

            const nonEmpty = this.data.filter(c => c > 0);
            const sorted = [...nonEmpty].sort((a,b) => a-b);

            for (var i=0; i<4; i++) {

                segments = []

                for (var j=0; j<4; j++) {

                    index = (i * 4) + j

                    const idx = sorted.findIndex(v => v >= this.data[index]);
                    const pct = idx / (sorted.length - 1 || 1);

                    if(this.data[index]) {

                        band = 3

                        if (pct >= 0.75) band = 0;
                        else if (pct >= 0.50) band = 1;
                        else if (pct >= 0.25) band = 2;

                    } else {

                        band = 4

                    }

                    segments.push({
                        id: index,
                        band: band,
                        count: this.data[index]
                    })

                }

                quadrants.push({
                    segments: segments
                })

            }

            return quadrants

        }

    }

}

</script>

<style scoped>

.wrapper {
	width: 100%;
	height: 100%;
}

.quadrants {
	width: 100%;
	height: 100%;
	user-select: none;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 20px;
    background-color: #fff;
}

.quadrant {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    background-color: #fff;
    grid-gap: 1px;
}

.segment {
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
	color: #fff;
}

.segment-value {
	position: absolute;
	border-radius: 100%;
	pointer-events: none;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	font-size: 21px;
	line-height: 24px;
	font-weight: 500;
}

.segment[data-band="0"] {
	background-color: rgba(72, 129, 187, 1);
	color: #fff;
}

.segment[data-band="1"] {
	background-color: rgba(72, 129, 187, 0.7);
	color: #fff;
}

.segment[data-band="2"] {
	background-color: rgba(72, 129, 187, 0.4);
	color: #fff;
}

.segment[data-band="3"] {
	background-color: rgba(72, 129, 187, 0.1);
	color: #7fa7cf;
}

.segment[data-band="4"] {
	background-color: #f4f4f4;
    color: #ddd;
	pointer-events: none;
}

.segment.is-selected {
	background-color: #ffb343!important;
	color: #fff;
}

.is-desktop .segment:hover {
	background-color: #19455c;
	color: #fff;
}

.label {
    position: absolute;
    font-size: 12px;
    font-weight: 400;
    text-transform: lowercase;
    position: absolute;
    line-height: 20px;
    background-color: #fff;
    display: flex;
    justify-content: center;
    white-space: nowrap;
}

.label span {
    font-size: 20px;
    line-height: 18px;
}

.label.is-top {
    left: 50%;
    top: 0px;
    width: 20px;
    height: calc(50% - 30px);
    text-align: center;
    padding: 10px 0px;
    writing-mode: vertical-lr;
    text-orientation: mixed;
    margin-left: -10px;
}

.label.is-bottom {
    left: 50%;
    bottom: 0px;
    height: calc(50% - 30px);
    width: 20px;
    text-align: center;
    padding: 10px 0px;
    writing-mode: vertical-lr;
    text-orientation: mixed;
    margin-left: -10px;
}

.label.is-top span,
.label.is-bottom span {
    line-height: 22px;
    padding: 2px 0px;
}

.label.is-left {
    left: 0px;
    top: 50%;
    height: 20px;
    padding: 0px 10px;
    margin-top: -10px;
    width: calc(50% - 30px);
    text-align: center;
}

.label.is-right {
    padding: 0px 10px;
    right: 0px;
    top: 50%;
    height: 20px;
    margin-top: -10px;
    width: calc(50% - 30px);
    text-align: center;
}

.label.is-left span,
.label.is-right span {
    padding: 0px 2px;
}

.center {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 60px;
    height: 60px;
    margin-left: -30px;
    margin-top: -30px;
    z-index: 2;
    text-align: center;
    background-color: #4881bb;
    color: #fff;
    line-height: 40px;
    border: 10px solid #fff;
    font-size: 12px;
    font-weight: 400;
    cursor: pointer;
    text-transform: uppercase;
    border-radius: 50%;
}

.center.is-selected {
	background-color: #ffb343!important;
    font-weight: 500;
	color: #fff;
}

.is-desktop .center:hover {
	background-color: #19455c;
}

</style>